import { crewOrderContext } from '~/app/features/order-middleware/orderMiddleware';
import { settingsContext } from '~/app/settingsMiddleware';
import { ClaimType } from '~/utils/constants';
import { checkIfPastReturnWindow } from '~/utils/order';
import { makeLoader, redirect } from '~/utils/routing';
import { getClaimTypeProgramName } from '~/utils/theme';

export const { loader, useLoaderData } = makeLoader(({ context }, appStore) => {
  const order = context.get(crewOrderContext);
  const settings = context.get(settingsContext);

  // ! the things we do for our biggest merchants, tolerating exceptions to the usual flow; all part of the joys of being a startup
  // ? might need to focus to just returns, but all crew requests are redirected
  if (order.storeId === 962 && order.shippingAddress?.countryCode === 'CA') {
    return redirect(
      'https://www.trueclassictees.com/apps/redo/returns-portal/login',
    );
  }

  // clear any existing claim state since this is the start of a new claim
  appStore.dispatch(appStore.actions.crewClaim.clearClaim());

  if (order.allowClaimTypeSelection) {
    return {
      ...order.allowClaimTypeSelection.params,
      returnProgramName:
        order.allowClaimTypeSelection.params.returnSelectionButtonTitle ??
        getClaimTypeProgramName(settings.theme, ClaimType.return),
      warrantyProgramName: getClaimTypeProgramName(
        settings.theme,
        ClaimType.warranty,
      ),
    };
  }

  const canWarranty =
    settings.warranty.isEnabled &&
    order.lineItems.every(checkIfPastReturnWindow(settings.return.isEnabled));

  const claimType = canWarranty ? ClaimType.warranty : ClaimType.return;

  return redirect(`../${claimType.toLowerCase()}`);
});
